export default {
  ready: false,
  connectionStatus: 1,
  isOpen: true, // 侧边栏是否打开
}



// WEBPACK FOOTER //
// ./app/resource/global/store/state.js